import React from 'react'
import { Input } from "antd";
import { UserAddOutlined } from "@ant-design/icons";
import { ButtonActiveModal } from '../../../../components/Buttons/ButtonActiveModal';
import { ToggleSectionButton } from '../../../../components/Buttons';


export const HeaderUser = ({ countUser = [], selectedSection = 0, searchValue = "", onChangeSwitch = () => { }, handleOpenModalCreate = () => { }, handleChange = () => { } }) => {

    return (
        <div className="w-full h-[170px] flex flex-col gap-4 md:h-[120px] md:flex-row md:items-center md:justify-between">
            <div className="flex items-center justify-center gap-4  self-center w-full">
                {countUser.map((typeUser, i) => {
                    return (
                        <div key={`${i}-categories`} className="flex flex-col items-center">
                            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: typeUser.color }} />
                            <span className="font-bold text-xs">{typeUser.number}</span>
                            <span className={`text-[10px] text-center`}>{typeUser.name}</span>
                        </div>
                    );
                })}
            </div>
            <div className="flex flex-col gap-4 px-4">
                <div className="px-8">
                    <ToggleSectionButton
                        sections={["Usuarios activos", "Usuarios inactivos"]}
                        handleSectionChange={onChangeSwitch}
                        selectedSection={selectedSection}
                    />
                </div>
                <div className="flex items-center justify-center gap-4 md:flex-row-reverse">
                    <ButtonActiveModal
                        icon={<UserAddOutlined />}
                        action={handleOpenModalCreate}
                        className="bg-primaryTwo hover:bg-primaryTwoHover px-20 py-2 flex justify-center items-center md:order-3 md:ml-auto"
                        size={{ w: 120, h: 32 }}
                        title="Crear usuario"
                    />
                    <Input.Search
                        placeholder="Búsqueda por nombre del usuario..."
                        onChange={handleChange}
                        value={searchValue}
                        className="w-full"
                    />
                </div>
            </div>
        </div>
    )
}
